import React from 'react';
import { Lock } from 'lucide-react';

type ModuleAccessDeniedDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
};

export const ModuleAccessDeniedDialog: React.FC<ModuleAccessDeniedDialogProps> = ({
  open,
  onClose,
  title,
  message,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/45 flex items-center justify-center p-4"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="bg-white rounded-xl shadow-2xl border border-red-200/80 max-w-md w-full overflow-hidden"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="module-access-denied-title"
      >
        <div className="px-6 pb-6 pt-8 text-center">
          <div className="relative mx-auto mb-5 flex h-14 w-14 items-center justify-center">
            <span className="absolute inset-0 rounded-2xl bg-red-100/70" aria-hidden="true" />
            <Lock className="relative h-7 w-7 text-red-600" strokeWidth={1.75} aria-hidden="true" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-red-600">Access restricted</p>
          <h2 id="module-access-denied-title" className="mt-2 text-lg font-bold text-gray-900">
            {title}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-gray-600">{message}</p>
          <button
            type="button"
            onClick={onClose}
            className="mt-6 inline-flex items-center justify-center rounded-lg border border-red-200 bg-white px-4 py-2.5 text-sm font-medium text-red-700 shadow-sm hover:border-red-300 hover:bg-red-50"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModuleAccessDeniedDialog;
